// e561c71c84520e04e36e4ce9b1e8000a0527df6f|className=IndustryApi|type=angular|apiName=am|apiEnumKey=AM|operationHash=16d8fd00411b6655b54abb41acd8482e77c39af4|kind=api-js

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';
import { parseOkResponseFromJSON } from '../../../parsers/OkResponse';

import { parseIndustryFromJSON } from '../../../parsers/Industry';

export class IndustryApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @description <p>📝 Static reference data, the same for every customer: no scope parameter and no authentication.</p>
   *
   * @tags IndustryApi
   * @name IndustryApiGetIndustryList
   * @summary Get all industries
   * @request GET:/industries
   */
  getIndustryList(
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/industries`,
        route: '/industries',
        method: 'GET',
        api: Api.AM,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseIndustryFromJSON,
    isContentArray: true,
  }),
      },
    );
  }

  static ɵfac = function IndustryApi_Factory(t) { return new (t || IndustryApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: IndustryApi, factory: IndustryApi.ɵfac, providedIn: 'root' });
}
